/**
 * Helper function to format price range for projects
 */
export const formatProjectPriceRange = (
  min?: number | null,
  max?: number | null
): string => {
  const hasMin = min !== null && min !== undefined && min > 0;
  const hasMax = max !== null && max !== undefined && max > 0;

  if (!hasMin && !hasMax) return '';
  if (hasMin && hasMax && min === max) {
    return `${(min / 1000000).toFixed(1).replace('.0', '')} mkr`;
  }
  if (hasMin && hasMax) {
    return `${(min / 1000000).toFixed(1).replace('.0', '')}-${(max / 1000000)
      .toFixed(1)
      .replace('.0', '')} mkr`;
  }
  if (hasMin) {
    return `Från ${(min / 1000000).toFixed(1).replace('.0', '')} mkr`;
  }
  if (hasMax) {
    return `Upp till ${(max / 1000000).toFixed(1).replace('.0', '')} mkr`;
  }
  return '';
};

/**
 * Helper function to format living space range for projects
 */
export const formatProjectLivingSpaceRange = (
  min?: number | null,
  max?: number | null
): string => {
  const hasMin = min !== null && min !== undefined && min > 0;
  const hasMax = max !== null && max !== undefined && max > 0;

  if (!hasMin && !hasMax) return '';
  if (hasMin && hasMax && min === max) {
    return `${min} m²`;
  }
  if (hasMin && hasMax) {
    return `${min}-${max} m²`;
  }
  if (hasMin) {
    return `Från ${min} m²`;
  }
  if (hasMax) {
    return `Upp till ${max} m²`;
  }
  return '';
};

/**
 * Helper function to format rooms range for projects
 */
export const formatProjectRoomsRange = (
  min?: number | null,
  max?: number | null
): string => {
  const hasMin = min !== null && min !== undefined && min > 0;
  const hasMax = max !== null && max !== undefined && max > 0;

  if (!hasMin && !hasMax) return '';
  if (hasMin && hasMax && min === max) {
    return `${min} rum`;
  }
  if (hasMin && hasMax) {
    return `${min}-${max} rum`;
  }
  if (hasMin) {
    return `Från ${min} rum`;
  }
  if (hasMax) {
    return `Upp till ${max} rum`;
  }
  return '';
};
